import { render, staticRenderFns } from "./AccountTypes.vue?vue&type=template&id=31b4ee9c"
import script from "./AccountTypes.vue?vue&type=script&lang=ts"
export * from "./AccountTypes.vue?vue&type=script&lang=ts"
import style0 from "./AccountTypes.vue?vue&type=style&index=0&id=31b4ee9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports